import axios from '@/util/request'
const prefix = '/order/api/v1'

const order = {
  

}

export default order
